module.exports = __webpack_public_path__ + "static/img/editor-type3.37714068.png";